export enum Feature {
  ACCESS = 'access',
  CORE = 'core',
  AUTH = 'auth',
  LOGS = 'logs',
  AUTOMATION = 'automation',
  DASHBOARD = 'dashboard',
  REPORTS = 'reports',
  SHARED = 'shared',
  APPROVAL = 'approval',
}
